export default __webpack_public_path__ + "static/km-mockup-0b4e1ef290ed97847a65efbbe62f6340.jpg";